import Repository from "../../repository";

export default {
    Register: (payload) => Repository.post(`/api/AuthenticationUserGateWay/Register`, payload),
    Login: (payload) => Repository.post(`/api/AuthenticationUserGateWay/Login`, payload),
    ChangePassword: (payload) => Repository.post(`/api/Guests/AuthenticationUserGateWay/ChangePassword`, payload),
    ChangeInfo: (payload) => Repository.post(`/api/Guests/AuthenticationUserGateWay/ChangeInfo`, payload),
    Logout: (payload) => Repository.post(`/api/Guests/AuthenticationUserGateWay/Logout`, payload),
    RefreshToken: (payload) => Repository.post(`/api/Guests/AuthenticationUserGateWay/RefreshToken`, payload),
    GetInfo: (payload) => Repository.post(`/api/Guests/AuthenticationUserGateWay/GetInfo`, payload),
    LogoutGateWay: (payload) => Repository.post(`/api/Guests/AuthenticationUserGateWay/LogoutGateWay`, payload),
    GetInfoNoAuther: (payload) => Repository.post(`/api/Guests/AuthenticationUserGateWay/GetInfoNoAuther`, payload),

}
